import { render, staticRenderFns } from "./TheModalAreaLaboratorio.vue?vue&type=template&id=3efde0b8&"
import script from "./TheModalAreaLaboratorio.vue?vue&type=script&lang=js&"
export * from "./TheModalAreaLaboratorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports